import * as React from 'react'
import { useState } from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { RequestContext } from '@utils'
import * as playerConfig from './integration/config'
import { PlaybackArea } from './integration/playbackArea'
import { PlaybackContentLink, PlayerIntegration, PlayerContentConfig } from '.'

type SimplePlayerProps = {
  requestContext: RequestContext
  pageType: playerConfig.PageType
  launchType: WpsRuntime.atv.wps.DeeplinkingLaunchType
  whisperCacheData?: PlayerContentConfig
  liveIncompatibleCallback?: () => void
  isEnabled?: boolean
}

export const SimplePlayer: React.StatelessComponent<SimplePlayerProps> = ({
  requestContext,
  pageType,
  launchType,
  whisperCacheData,
  liveIncompatibleCallback,
  isEnabled = true,
  children,
}) => {
  const [content, setContent] = useState<PlaybackContentLink | undefined>()
  const { sessionID, marketplaceID, customerID, locale } = requestContext
  const playerConfig = {
    sessionId: sessionID,
    marketplaceId: marketplaceID,
    customerId: customerID,
    locale,
    playerBeta: false,
    useDefaultView: true,
    pageType,
  }

  if (!isEnabled) {
    return <>{children}</>
  }

  return (
    <>
      {launchType === 'EMBEDDED' && (
        <PlayerIntegration
          playerConfig={playerConfig}
          playbackLinkData={content}
          whisperCacheData={whisperCacheData}
          liveIncompatibleCallback={liveIncompatibleCallback}
          onClosed={() => setContent(undefined)}
        />
      )}
      <PlaybackArea
        pageType={pageType}
        onPlay={setContent}
        launchType={launchType}
        trailerLaunchType={launchType}>
        {children}
      </PlaybackArea>
    </>
  )
}
